import { Collection, type QueryParams } from '@kp/js-model';
import { BaseModel } from '@/models/BaseModel';
import { BaseDataProxy } from '@/models/BaseDataProxy';
import { readonly, ref, type DeepReadonly, type Ref } from 'vue';
import type { QueryOptions } from '@kp/js-model/dist/SharedTypes';

export class BaseCollection<T extends BaseModel> extends Collection<T> {
    protected modelCls: any;
    protected proxy: BaseDataProxy | null = null;
    protected _loading: Ref<boolean> = ref(false);
    public loading: DeepReadonly<Ref<boolean>>;

    public constructor() {
        super();
        const refModels: Ref<T[]> = ref([]);
        this._models = refModels.value;
        this.loading = readonly(this._loading);
    }

    public async query(queryParams?: QueryParams | null, opts?: QueryOptions | null): Promise<this> {
        this._loading.value = true;
        try {
            await super.query(queryParams, opts);
        } finally {
            this._loading.value = false;
        }
        return this;
    }

    public getDataProxy(): BaseDataProxy {
        if (!this.proxy) {
            this.proxy = new BaseDataProxy();
        }
        return this.proxy;
    }

    public getServerTotal(): number {
        return this.proxy?.serverTotal ?? 0;
    }
}
